import {Utils} from './utils';
import {Constants} from '../constants';
import includes from 'lodash-es/includes';
import { Injectable } from '@angular/core';

@Injectable()
export class SegmentHandler {
    /**
     * List of allowed segments
     * @var {Array<object>}
     */
    private _allowedSegments: Array<string> = [];

    /**
     * List of blacklisted segments
     * @var {Array<string>}
     */
    private _blacklistedSegments: Array<string> = [];

    /**
     * List of segments passed on query param
     * @var {Array<string>}
     */
    private _segments: Array<string> = [];

    /**
     * Selected segment
     * @var {string}
     */
    private _selectedSegment = '';

    /**
     * Default segment in app configuration
     * @var {string}
     */
    private _appDefaultSegment = '';

    /**
     * Initialize variables
     *
     * @returns {void}
     */
    public initialize(allowedSegments: Array<string>, blacklistedSegments: Array<string>, defaultSegment: string): SegmentHandler {
        this._allowedSegments = allowedSegments;
        this._appDefaultSegment = defaultSegment;
        this._blacklistedSegments = blacklistedSegments;

        this._setSegmentsFromQueryParams();
        this._setDefaultSelectedSegment();

        return this;
    }

    /**
     * Retrieves the segments based on the query param and allowed segments
     *
     * @param allowedSegments
     * @returns {Array<string>}
     */
    public getSegments(): Array<string> {
        return this._segments;
    }

    /**
     * Retrieves the blacklisted segments specified in config manager
     * @returns {Array<string>}
     */
    public getBlacklistedSegments(): Array<string> {
        return this._blacklistedSegments;
    }

    /**
     * Retrieves the default selected segment
     *
     * @returns {string}
     */
    public getSelectedSegment(): string {
        return this._selectedSegment;
    }

    /**
     * Gets the default selected segment from the "defaultSegment" query param
     *
     * @returns {void}
     */
    private _setDefaultSelectedSegment(): void {
        let defaultSegment = Utils.getValueFromQueryParam(Constants.PARAM_DEFAULT_SEGMENT);

        // If defaultSegment is not on the query param, we default it to the first one on that list
        // If segments query param is empty, default to "tickets"
        if (Object.keys(this._segments).length === 0) {
            defaultSegment = includes(this._allowedSegments, defaultSegment)
                ? defaultSegment
                : this._appDefaultSegment;
        } else {
            if (!includes(this._segments, defaultSegment)) {
                defaultSegment = (!!this._segments[0]) ? this._segments[0] : this._appDefaultSegment;
            }
        }

        this._selectedSegment = defaultSegment;
    }

    /**
     * Gets the segments from the "segments" query param and sets the current segments if they are valid
     *
     * @private
     * @returns {void}
     */
    private _setSegmentsFromQueryParams(): void {
        const segments = Utils.getValueFromQueryParam(Constants.PARAM_SEGMENTS).split(',');

        this._segments = segments.filter((value, index) => {
            return !includes(this._blacklistedSegments, value) && includes(this._allowedSegments, value) && segments.indexOf(value) === index;
        });
    }
}
